import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import * as localStyles from "../DreamRow.css";

export function DreamNameExpansionButton({
    isExpanded,
    onToggle,
}: {
    isExpanded: boolean;
    onToggle: () => void;
}) {
    return (
        <button
            type="button"
            className={localStyles.nameExpansionButton}
            style={{
                gridColumn: 3,
                gridRow: isExpanded ? `1 / span 2` : undefined,
            }}
            aria-label={
                isExpanded ? `Collapse dream name` : `Show full dream name`
            }
            aria-expanded={isExpanded}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onToggle();
            }}
        >
            <Glyphicon
                icon={
                    isExpanded
                        ? EGlyphicon["chevron-up"]
                        : EGlyphicon["chevron-down"]
                }
            />
        </button>
    );
}
